import { Component, Input, OnInit } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { DownloadComponent } from "src/app/shared/components/download/download.component";
import { Group } from "src/app/shared/models/group.model";
import { AdminService } from "../../admin/admin-service";

@Component({
  selector: "app-group-attachments",
  templateUrl: "./group-attachments.component.html",
  styleUrls: ["./group-attachments.component.scss"],
})
export class GroupAttachmentsComponent implements OnInit {
  subs: Subscription[] = [];
  @Input() group: Group;
  member_status: boolean;
  members_list: any;
  attachment_status: boolean;
  attachment_list: any;
  constructor(private service: AdminService, private dialog: MatDialog) {}
  ngOnInit(): void {
    if (this.group) {
      this.attachmentList(this.group.id);
    }
  }
  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.forEach((sub) => sub.unsubscribe());
    }
  }

  download(param) {
    const data = {
      title: "Download",
      action: "create",
      dataBinary: param.fileBase64,
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "70%";
    dialogConfig.height = "80%";
    dialogConfig.data = data;
    dialogConfig.panelClass = "mat-dialog-box";
    const dl = this.dialog.open(DownloadComponent, dialogConfig);
    this.subs.push(
      dl.afterClosed().subscribe(
        (response: any) => {
          //this.attachmentList(this.groupId);
        },
        (error) => {}
      )
    );
  }

  attachmentList(param) {
    this.attachment_status = false;
    this.subs.push(
      this.service.groupAttachment(param).subscribe((response) => {
        this.attachment_list = response.data;

        if (this.attachment_list) {
          this.attachment_status = true;
        }
      })
    );
  }
}
